<template>
  <div class="OtheHeader">
    <div class="content">
      <div class="logoImg">
        <div style="margin-top: 10px; display: flex;">
          <div>
            <router-link to="/"><img class="logo" src="../assets/img/logo.svg" alt /></router-link>
          </div>
          <div>
            <img class="logoEPC" src="../assets/img/logo@2x.png" align="middle" alt="">
          </div>
        </div>
        <div class="nav">
          <ul>
            <li>
              <router-link to="Case">行业/案例</router-link>
            </li>
            <li>
              <a href="#" @click="goProduct">产品</a>
              <!-- <router-link to="Product">产品</router-link> -->
            </li>
            <li>
              <router-link to="Customized">服务/定制</router-link>
            </li>
            <li>
              <router-link to="Journalism">新闻</router-link>
            </li>
            <li>
              <router-link to="AboutUs">关于我们</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div>
        <ul class="icon">
          <li>
            <div style="display:flex;align-items:center;">
              <img src="../assets/img/gb.png" v-if="iconname=='sousuo'" style="width:16px;height:16px;cursor:pointer;" @click="iconname = ''">
              <el-input size="mini" v-if="iconname=='sousuo'" style="margin:0 10px;" v-model="searchKey"></el-input>
              <img class="iconImg" v-if="iconname=='sousuo'" src="../assets/img/sousuo_active.png" @click="sousuo" style="cursor:pointer;">
              <img class="iconImg" v-else src="../assets/img/sousuo.png" @click="iconname = 'sousuo'" style="cursor:pointer;">
            </div>
            <div class="ssjg" v-if="iconname=='sousuo' && list.length">
              <p v-for="item in list" :key="item.id" class="ssjg_item" @click="todetail(item)">
                <span v-if="item.type=='1'" class="ssjg_icon">案例</span>
                <span v-if="item.type=='2'" class="ssjg_icon">新闻</span>
                <span v-if="item.type=='3'" class="ssjg_icon">产品</span>
                <span class="ssjg_text">{{item.content}}</span>
              </p>
            </div>
          </li>
          <li style="width: 1px; height: 25px; background-color: #CCCCCC; line-height: 62px; margin-left: 33px;">
            &nbsp;
          </li>
          <li style="margin-left: 35px;" @mouseenter="iconsname = 'qq'" @mouseleave="iconsname = ''" class="weixin">
            <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=467218135&site=在线客服&menu=yes">
              <img class="iconImg" v-if="iconsname=='qq'" src="../assets/img/qq_active.png" alt="">
              <img class="iconImg" v-else src="../assets/img/qq.png" alt="">
              <div :class="iconsname=='qq' ? 'erweima_bag erweima_bag_show' : 'erweima_bag'">
                <img class="erweima_img" src="../assets/img/qqqq.png" alt="">
              </div>
            </a>
          </li>
          <li @mouseenter="iconsname = 'weixin'" @mouseleave="iconsname = ''" class="weixin">
            <img class="iconImg" v-if="iconsname=='weixin'" src="../assets/img/weixin_active.png" alt="">
            <img class="iconImg" v-else src="../assets/img/weixin.png" alt="">
            <div :class="iconsname=='weixin' ? 'erweima_bag erweima_bag_show' : 'erweima_bag'">
              <img class="erweima_img" src="../assets/img/weixinlf.png" alt="">
            </div>
          </li>
          <li @mouseenter="iconsname = 'weibo'" @mouseleave="iconsname = ''">
            <a target="_blank" href="https://weibo.com/linefound">
              <img class="iconImg" v-if="iconsname=='weibo'" src="../assets/img/weibo_active.png" alt="">
              <img class="iconImg" v-else src="../assets/img/weibo.png" alt="">
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="bannerTitle" :style="banner">
      <!-- <img src="../assets/img/banner.png" alt style="width: 100%" /> -->
      <div class="bannerContent">
        <div class="size">
          <p>[加载我的标签</p>
          <p style="margin-top: 18px;">拓展你的视界]</p>
          <p style="font-size: 20px; margin-top: 28px; font-weight:400;">Loading my tag，Broaden your vision</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let bannerList = {
  Home: require('../assets/img/Product.png'),
  Case: require('../assets/img/Case.png'),
  CaseDetail: require('../assets/img/Case.png'),
  Product: require('../assets/img/Product.png'),
  ProductTab: require('../assets/img/Product.png'),
  ProductTwoTab: require('../assets/img/Product.png'),
  ProductTabDetail: require('../assets/img/Product.png'),
  Customized: require('../assets/img/Customized.png'),
  Dzfw: require('../assets/img/Customized.png'),
  Yfxq: require('../assets/img/Customized.png'),
  Azgd: require('../assets/img/Customized.png'),
  Journalism: require('../assets/img/Journalism.png'),
  JournalismDetail: require('../assets/img/Journalism.png'),
  AboutUs: require('../assets/img/AboutUs.png'),
}

export default {
  name: "OtheHeader",
  props: {
    msg: String
  },
  data() {
    return {
      iconname: '',
      iconsname: '',
      searchKey: '',
      list: [],
      banner: {
        backgroundImage: `url(${bannerList[this.$route.name]})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%"
      }
    };
  },
  methods: {
    todetail(item) {
      if (item.type=='1') {
        this.$router.push({name: 'CaseDetail', query: {id: item.id }})
      } else if (item.type=='2') {
        this.$router.push({name: 'JournalismDetail', query: {id: item.id }})
      } else if (item.type=='3') {
        this.$router.push({name: 'ProductTabDetail', query: {id: item.id}})
      }
    },
    sousuo() {
      this.fetchPost("index/getSearchList", {
        searchKey: this.searchKey,
        listRows: 10,
        p: 1
      })
        .then(res => {
          this.list = res.data.list;
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    goProduct() {
      if (this.$route.name == 'Product') {
        location.reload()
      } else {
        this.$router.push({name: 'Product'})
      }
    }
  },
  mounted() {
    console.log();
  }
};
</script>
<style scoped lang="less">
.OtheHeader {
  width: 100%;
  // height: 62px;
  //   box-shadow: 4px 4px 4px #F0EDF1;
  .content {
    margin: 0 auto;
    width: 1250px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 62px;
    .logoImg {
      display: flex;
      align-items: center;
      .logo {
        width: auto;
        height: 30px;
        margin-top: -10px;
      }
      .logoEPC {
        width: auto;
        height: 28px;
        margin-left: 10px;
        margin-top: -15px;
      }
      .nav {
        // margin-left: 57px;
        overflow: hidden;
        li {
          display: inline-block;
          height: 60px;
          line-height: 62px;
          // width: 66px;
          padding: 0 5px;
          margin-left: 30px;
          font-size: 16px;
          font-weight: 500;
          color: #333333;
          text-align: center;
          a {
            color: #333333;
            text-decoration: none;
          }
          a:hover {
            color: #00a8eb;
            height: 60px;
            line-height: 62px;
            display: inline-block;
            border-bottom: 3px solid #00a8eb;
          }
        }
        .active {
          color: #00a8eb;
          border-bottom: 3px solid #00a8eb;
        }
      }
    }
    .icon {
      li {
        display: inline-block;
        margin-left: 43px;
        position: relative;
        .iconImg {
          width: 23px;
          height: 23px;
        }
      }
    }
    .ssjg {
      width:300px;
      height:239px;
      background-color: #FFFFFF;
      overflow-y: auto;
      box-shadow:0px 2px 6px rgba(0,0,0,0.1);
      padding: 16px 25px;
      position: absolute;
      left: -65px;
      top: 40px;
      z-index: 999;
      .ssjg_item {
        cursor: pointer;
        margin-bottom: 5px;
        .ssjg_icon {
          display: inline-block;
          color: #999999;
          font-size: 14px;
          margin-right: 10px;
        }
        .ssjg_text {
          color: #666666;
          font-size: 14px;
          font-weight: 500;
        }
      }
    }
    .weixin {
      position: relative;
      cursor: pointer;
      .erweima_bag {
        height: 0;
        background-color: #FFFFFF;
        box-shadow:0px 3px 20px rgba(0,0,0,0.2);
        overflow: hidden;
        transition: all .5s;
        box-sizing: border-box;
        position: absolute;
        top: 50;
        left: -80px;
        z-index: 999;
        .erweima_img {
          display: inline-block;
          width: 116px;
          height: 116px;
          padding: 7px;
        }
      }
      .erweima_bag_show {
        height: 130px;
      }
    }
  }
  .bannerTitle {
    height: 340px;
    .bannerContent {
      margin: 0 auto;
      width: 1197px;
      padding-top: 80px;
      box-sizing: border-box;
      .size {
        float: right;
      }
      p {
        width: 525px;
        text-align: right;
        font-size: 46px;
        font-weight: bold;
        color: #ffffff;
      }
      p:first-child {
        text-align: left;
      }
    }
  }
}
</style>
